import { render, staticRenderFns } from "./StructureNodeMappingSetting.vue?vue&type=template&id=dbf0f7e0&"
import script from "./StructureNodeMappingSetting.vue?vue&type=script&lang=js&"
export * from "./StructureNodeMappingSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports